<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card class="mx-auto" max-width="400">
          <v-card-text>
            <h2 class="title mb-2">Payment cancelation</h2>

            <v-form ref="form" v-model="valid">
              <v-alert type="error"> Payment canceled </v-alert>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/* eslint-disable no-debugger */

export default {
  name: 'StripeCancel',

  data: () => ({
    //    tags: [],
    error: null,
    sent: false
  }),
  mounted() {
    document.title = 'Stripe Subscriptions';
  },
  created: async function () {},
  methods: {},
  computed: {}
};
</script>
<style></style>
